import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import Cadastro from "./pages/Cadastro";
import Login from "./pages/Login";
import Cardapio from "./pages/Cardapio";
import Pedidos from "./pages/Pedidos";
import Identificadores from "./pages/Identificadores";
import Usuario from "./pages/Usuario";
import Chamado from "./pages/chamado";
import TelaBloqueado from "./pages/bloqueio/TelaBloqueado";
import TelaInativo from "./pages/bloqueio/TelaInativo";
import FormaPagamento from "./pages/formaPagamento";
import Delivery from "./pages/delivery";
import CupomDesconto from "./pages/delivery/CupomDesconto";
import HorarioAbertura from "./pages/HorarioAbertura";
import RouteWithLayout from "./pages/Generico/RouteWithLayout";
import Configuracoes from "./pages/configuracoes";
import Empresas from "./pages/empresas";
import Dashboard from "./pages/Dashboard";
import Avaliacao from "./pages/Avaliacao";
import Clientes from "./pages/clientes";
import AlterarSenha from "./pages/RecuperarSenha/alterarSenha";
import RecuperarSenha from "./pages/RecuperarSenha";
import CadastroEmpresaCliente from "./pages/CadastroEmpresaCliente";
import ConfigNewUser from "./pages/CadastroEmpresaCliente/configNewUser";
import TempoExpiradoTeste from "./pages/bloqueio/TempoExpiradoTeste";
import ExtraTime from "./pages/CadastroEmpresaCliente/extraTime";
import CustomerSalesByType from "./pages/clientes/Sales";
import Prompt from "./pages/Prompt";
import MainLayout from "./components/MainLayout";

const TOKEN = "id_token";

const isAuthenticated = () => !!localStorage.getItem(TOKEN);

const isAdmin = () => {
  const profile = JSON.parse(localStorage.getItem("_profile"));
  return profile?.admin;
};

const PrivateRoute = () => {
  const location = useLocation();
  return isAuthenticated() ? (
    <RouteWithLayout layout={MainLayout}>
      <Outlet />
    </RouteWithLayout>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

const AdminRoute = () => {
  const location = useLocation();
  return isAdmin() ? (
    <RouteWithLayout layout={MainLayout}>
      <Outlet />
    </RouteWithLayout>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

const RoutesApp = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/RecuperarSenha" element={<RecuperarSenha />} />
      <Route path="/AlterarSenha/:token" element={<AlterarSenha />} />
      <Route path="/Block" element={<TelaBloqueado />} />
      <Route path="/Inativo" element={<TelaInativo />} />
      <Route path="/NovaEmpresa" element={<CadastroEmpresaCliente />} />
      <Route path="/NovaEmpresaUser" element={<CadastroEmpresaCliente />} />
      <Route path="/ConfigNewUser/:token" element={<ConfigNewUser />} />
      <Route path="/TempoExpirado" element={<TempoExpiradoTeste />} />
      <Route path="/TempoExtra" element={<ExtraTime />} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Pedidos />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Cardapio" element={<Cardapio />} />
        <Route path="/Cadastro" element={<Cadastro />} />
        <Route path="/chamados" element={<Chamado />} />
        <Route path="/Pedidos" element={<Pedidos />} />
        <Route path="/Identificadores" element={<Identificadores />} />
        <Route path="/Usuario/:id" element={<Usuario />} />
        <Route path="/Usuario" element={<Usuario />} />
        <Route path="/FormaPagamento" element={<FormaPagamento />} />
        <Route path="/Delivery" element={<Delivery />} />
        <Route path="/CupomDesconto" element={<CupomDesconto />} />
        <Route path="/HorarioAbertura" element={<HorarioAbertura />} />
        <Route path="/Configuracoes" element={<Configuracoes />} />
        <Route path="/Avaliacoes" element={<Avaliacao />} />
        <Route path="/Clientes" element={<Clientes />} />
        <Route path="/CustomerSalesByType" element={<CustomerSalesByType />} />
      </Route>

      <Route element={<AdminRoute />}>
        <Route path="/Empresas" element={<Empresas />} />
        <Route path="/prompt" element={<Prompt />} />
        {/* <Route path="/Dashboard" element={<Dashboard />} /> */}
      </Route>
    </Routes>
  </BrowserRouter>
);

export default RoutesApp;
